import { styled } from '@mui/material/styles';

interface StyledTextTruncatedProps {
  width?: string;
}

const StyledTextTruncated = styled('span')<StyledTextTruncatedProps>`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: ${({ width }) => width || '100%'};
`;

export default StyledTextTruncated;
